import { render, staticRenderFns } from "./PageListWrapper.vue?vue&type=template&id=55b2914e&scoped=true"
import script from "./PageListWrapper.vue?vue&type=script&lang=js"
export * from "./PageListWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b2914e",
  null
  
)

export default component.exports